import { Alert } from "@/components/Alert"
import { FormattedMessage } from "react-intl"

export const Waiting = ({ title, confirmation }: { title?: string; confirmation?: number }) => {
  const isOrderIbanWaiting = /order card.*waiting.*issue/.test(title?.toLowerCase() ?? "")
  return (
    <div className="received">
      <h1 className="uppercase">{title ?? "Received Crypto"}</h1>
      <p className="mb-[30px]">
        <FormattedMessage id="blockchain" /> {confirmation ?? 0}
      </p>
      {!isOrderIbanWaiting && (
        <Alert>
          <div className="font-normal">
            <p>
              Please note that the IBAN issuance process may take some time. You can close this page - we will notify you by email as soon as your
              IBAN is issued. If you have any questions, please contact us at{" "}
              <a className="text-main-main" href="mailto:support@tranzbase.com">
                support@tranzbase.com.
              </a>
            </p>
          </div>
        </Alert>
      )}
    </div>
  )
}
